<template>
  <div>
    <el-table ref="RebuttalsTable" :data="tableData" empty-text="No Rebuttal Data Available" max-height="425" stripe :summary-method="getSummaries" show-summary>
      <el-table-column prop="coder" label="Coder" sortable v-if="rebuttalType === 'CODER'">
        <template slot-scope="scope">
          <div>{{ scope.row.coder }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="auditor" label="Auditor" sortable v-if="rebuttalType === 'AUDITOR'">
        <template slot-scope="scope">
          <div>{{ scope.row.auditor }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="totalRecords" label="Total Records" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.totalRecords }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="recordsWithFindings" label="Records With Findings" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.recordsWithFindings }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="coderAgrees" label="Coder Agrees" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.coderAgrees }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="outcome1" label="Upheld Recommendation" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.outcome1 }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="outcome2" label="Recommendation Changed - Additional Documentation Provided" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.outcome2 }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="outcome3" label="Recommendation Changed - Department Policy" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.outcome3 }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="outcome4" label="Recommendation Changed - Payor Specific Guidelines" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.outcome4 }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="outcome5" label="Recommendation Changed - Auditor Agrees" sortable>
        <template slot-scope="scope">
          <div>{{ scope.row.outcome5 }}</div>
        </template>
      </el-table-column>

      <el-table-column label="Details" width="150" prop="details" v-if="!hideDetails">
        <template slot-scope="scope">
          <el-button style="margin-left: 5px;" @click.native.prevent="updateAcctList(scope.row)" plain round size="mini" icon="mdi mdi-details" title="Records Included" circle> </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import dashboardHelper from '@/mixins/dashboardHelper'
  export default {
    name: 'RebuttalsTable',
    mixins: [dashboardHelper],
    props: {
      tableData: {
        type: Array,
        required: true
      },
      hideDetails: {
        type: Boolean,
        default: false
      },
      updateAcctList: {
        type: Function,
        required: true
      },
      rebuttalType: {
        type: String,
        required: true
      }
    },
    methods: {
      getSummaries(param) {
        return this.getSummary(param)
      }
    }
  }
</script>

<style scoped></style>
